// extracted by mini-css-extract-plugin
export var form = "_49-0";